import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Button, translate } from '@haldor/ui';

var AddLinkForm = /*#__PURE__*/function (_Component) {
  _inherits(AddLinkForm, _Component);

  var _super = _createSuper(AddLinkForm);

  function AddLinkForm() {
    var _this;

    _classCallCheck(this, AddLinkForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        if (_this.props.onSubmit != null) {
          _this.props.onSubmit(values).then(function () {
            resolve(1);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      event.preventDefault();

      if (_this.props.onCancel != null) {
        _this.props.onCancel();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: "1px solid red"
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: "1rem",
          color: "red"
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: "1rem",
          color: "red"
        }
      }, warning)));
    });

    return _this;
  }

  _createClass(AddLinkForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          translate = _this$props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        className: "form form-component",
        onSubmit: handleSubmit(this.submit)
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: 0
        }
      }, this.props.translate('Web link'), "*"), /*#__PURE__*/React.createElement(Field, {
        component: this.renderInput,
        type: "text",
        name: "url"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Link name')), /*#__PURE__*/React.createElement(Field, {
        component: this.renderInput,
        type: "text",
        name: "title"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting,
        onClick: handleSubmit(this.submit),
        type: "primary"
      }, this.props.initialValues != null ? translate('Save') : translate('Add')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onCancel,
        disabled: submitting,
        type: "secondary"
      }, translate('Cancel'))))));
    }
  }]);

  return AddLinkForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(reduxForm({
  form: 'AddLinkForm',
  destroyOnUnmount: true
})(AddLinkForm));